<template>
  <div class="left_block branches">
    <p class="header">Все филиалы</p>

    <BranchesFilter
      :rows="rows"
      :search="search"
      @change="loadData"
      @restore="restoreChecked"
      @delete-checked="deleteChecked"
      @open-modal="openBranchCreateModal"
    />

    <BranchesTable
      :is-loading="isLoading"
      :rows="rows"
      :branches-list="branchesList"
      :total-count="totalCount"
      @delete-branch="deleteBranch"
      @restore="restoreBranch"
      @changePage="changePage"
      @init-sort="initSort"
    />

    <b-modal :active.sync="branchCreateModal" has-modal-card scroll="keep">
      <BranchesCreate
        :new-regions="newRegions"
        :new-branch="newBranch"
        :modal-info="modal"
        @add-region="addRegion"
        @remove-region="removeRegion"
        @close-modal="closeBranchCreateModal"
        @create-branch="createBranch"
      />
    </b-modal>
  </div>
</template>

<script>
import BranchesFilter from '@/components/admin/branches/BranchesFilter'
import BranchesTable from '@/components/admin/branches/BranchesTable'
import BranchesCreate from '@/components/admin/branches/BranchesCreate'
import { toastInfo } from '@/lib/toastCfg'

export default {
  components: {
    BranchesFilter,
    BranchesTable,
    BranchesCreate
  },
  data() {
    return {
      branchCreateModal: false,
      isLoading: true,
      modal: {
        header: 'Добавление филиала',
        button: 'Добавить',
        action: 'create-branch',
        creation: true,
        required: true
      },
      newBranch: {
        name: '',
        address: '',
        contact: '',
        id: ''
      },
      rows: {
        checked: []
      },
      search: {
        name: '',
        trashed: false,
        page: 1,
        sort: 'name',
        sort_type: 'desc'
      },
      newRegions: [
        {
          name: ''
        }
      ]
    }
  },
  mounted() {
    this.loadData()
  },
  computed: {
    totalCount() {
      return this.$store.state.branches.branchesList.total
    },
    branchesList() {
      return this.$store.state.branches.branchesList.branches
    }
  },
  methods: {
    initSort(fieldName, sortType) {
      this.search.sort_type = sortType
      this.search.sort = fieldName
      this.loadData()
    },
    loadData() {
      this.isLoading = true
      const qs = require('qs')
      const params = {}
      Object.keys(this.search).forEach((el) => {
        if (this.search[el] && this.search[el] !== 0) {
          params[el] = this.search[el]
        }
      })
      this.$axios2
        .get('branches?' + qs.stringify(params))
        .then((resp) => {
          this.isLoading = false
          this.$store.commit('setBranchesList', { list: resp.data })
        })
        .catch((err) => {
          this.$errorToast(err)
          this.isLoading = false
        })
    },
    addRegion() {
      this.newRegions.push({
        name: ''
      })
    },
    removeRegion(index) {
      this.newRegions.splice(index, 1)
    },
    changePage(pageNumber) {
      this.search.page = pageNumber
      this.loadData()
    },
    restoreBranch(branchId) {
      this.$axios2
        .patch('branches/' + branchId)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.loadData()
        })
        .catch(this.$errorToast)
    },
    restoreChecked() {
      for (let i = 0; i < this.rows.checked.length; i++) {
        this.restoreBranch(this.rows.checked[i].id)
      }
      this.rows.checked = []
    },
    deleteBranch(branchId) {
      this.$axios2
        .delete('branches/' + branchId)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.loadData()
        })
        .catch(this.$errorToast)
    },
    deleteChecked() {
      for (let i = 0; i < this.rows.checked.length; i++) {
        this.deleteBranch(this.rows.checked[i].id)
      }
      this.rows.checked = []
    },
    createBranch() {
      this.$axios2
        .post('branches', this.newBranch)
        .then((response) => {
          this.$buefy.toast.open(toastInfo())
          this.loadData()
          this.closeBranchCreateModal()
          this.newRegions.forEach((region) => {
            this.$axios2
              .post('branches/' + response.data.id + '/districts', {
                name: region.name
              })
              .then(() => {
                this.$buefy.toast.open(toastInfo())
              })
              .catch(this.$errorToast)
          })
        })
        .catch(this.$errorToast)
    },
    openBranchCreateModal() {
      this.newBranch = {
        name: '',
        address: '',
        contact: '',
        id: ''
      }
       this.newRegions = [
        {
          name: ''
        }
      ]
      this.branchCreateModal = true
    },
    closeBranchCreateModal() {
      this.branchCreateModal = false
    }
  }
}
</script>
